export default "__VITE_ASSET__CgjYTC0a__"